const confirmPostDelete = (vm) => {
    return vm.$bvModal
        .msgBoxConfirm("Are you sure you want to delete this post?", {
            cancelTitle: "No",
            centered: true,
            okTitle: "Yes",
            okVariant: "danger",
            title: "Delete Post",
        })
        .then((value) => {
            return value;
        })
        .catch((err) => {
            console.error(err);
            return null;
        });
};

export { confirmPostDelete };
